/* eslint-disable */
import React from 'react';

const ArrowIcon = () => (
    <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9116 0.646691C10.7163 0.451429 10.3997 0.451429 10.2045 0.646691C10.0092 0.841953 10.0092 1.15854 10.2045 1.3538L13.2929 4.44223H0.5C0.223858 4.44223 0 4.66609 0 4.94223C0 5.21837 0.223858 5.44223 0.5 5.44223H13.142L10.2045 8.37979C10.0092 8.57505 10.0092 8.89163 10.2045 9.08689C10.3997 9.28216 10.7163 9.28216 10.9116 9.08689L14.7781 5.22035C14.9734 5.02508 14.9734 4.7085 14.7781 4.51324L10.9116 0.646691Z" fill="#00B7FF" />
    </svg>
);

export default ArrowIcon;